function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#16191C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 11h18v2H3zM13.004 17.68v4.257h-2v-4.265l-2.021 2.022-1.415-1.415 3.018-3.017-.002-.002 1.414-1.414.002.002.002-.002 1.414 1.414-.002.002 3.018 3.017-1.415 1.415-2.013-2.014zM10.996 6.32V2.062h2v4.266l2.021-2.022 1.415 1.415-3.018 3.017.002.002-1.414 1.414-.002-.002-.002.002-1.414-1.414.002-.002-3.018-3.017 1.415-1.415 2.013 2.014z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;